import type {PermissionsRecordType} from '../permissions';

export const testDrivePermissions = {
  readTestDrive: {
    actionId: 'READ',
    resourceId: 'TEST_DRIVE',
    scopes: [],
  },
  createTestDrive: {
    actionId: 'CREATE',
    resourceId: 'TEST_DRIVE',
    scopes: [],
  },
  editTestDrive: {
    actionId: 'UPDATE',
    resourceId: 'TEST_DRIVE',
    scopes: [],
  },
  deleteTestDrive: {
    actionId: 'DELETE',
    resourceId: 'TEST_DRIVE',
    scopes: [],
  },
} satisfies PermissionsRecordType;
